import { useNavigate } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function Topics() {
  const navigate = useNavigate();
  return (
    <div>
      <section className="relative w-full overflow-hidden">
        <div className="relative h-44 w-full md:h-52">
          <img
            src="https://readdy.ai/api/search-image?query=%E5%8F%A4%E4%BB%A3%E4%B9%A6%E5%8D%B7%E6%AF%9B%E7%AC%94%E5%A2%A8%E7%A0%9A%E4%B8%8E%E7%87%8E%E7%81%AB%E7%BA%A2%E5%8D%B0%E7%AB%A0%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E8%83%8C%E6%99%AF%EF%BC%8C%E6%9A%97%E9%87%91%E8%89%B2%E8%B0%83%E8%89%BA%E6%9C%AF%E6%84%9F&width=1600&height=420&seq=topic-banner-2026&orientation=landscape"
            alt="古风漫画网题材专题横幅"
            className="absolute inset-0 h-full w-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 to-foreground-950/30"></div>
          <div className="relative z-10 container-x flex h-full flex-col justify-center">
            <nav className="flex items-center gap-1.5 text-sm text-background-300" aria-label="面包屑">
              <button onClick={() => navigate("/")} className="cursor-pointer hover:text-background-50">首页</button>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-accent-300">题材专题</span>
            </nav>
            <h1 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-4xl">题材专题</h1>
            <p className="mt-1.5 text-sm text-background-200">读懂古风漫画的题材脉络、创作套路与读者故事</p>
          </div>
        </div>
      </section>

      <div className="container-x py-12">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {topics.map((topic) => (
            <article
              key={topic.id}
              onClick={() => navigate(`/topic/${topic.id}`)}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-shadow hover:shadow-md sm:flex-row"
            >
              <div className="h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-56 md:w-60">
                <img src={topic.image} alt={topic.title} className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="tag-chip">{topic.category}</span>
                  <span className="text-xs text-foreground-500">{topic.date}</span>
                </div>
                <h2 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                  {topic.title}
                </h2>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                  {topic.tags.map((t) => (
                    <span key={t} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-900">#{t}</span>
                  ))}
                  <span className="ml-auto flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line"></i>{topic.readTime}阅读
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}